<template>
  <div class="wrapper">
    <el-alert
      v-if="inModal"
      title="WARNING"
      show-icon
      :closable="false"
      description="After After approval, the changes will be saved regardless of the form from which the modal was opened."
      type="warning"
    >
    </el-alert>
    <div class="nav">
      <div>
        <h1 class="nav--title" v-if="!inModal">
          {{ getRouteName($route) }} {{ titleAddition }}
        </h1>
        <h1 class="nav--title" v-else>{{ modalLabel }}</h1>
        <p v-show="subtitle">{{ subtitle }}</p>
      </div>
      <slot name="middle"></slot>
      <div v-show="!hideLanguageSwitcher">
        <language-switcher />
      </div>
      <div>
        <slot>
          <router-link
            :to="{ ...redirectRoute, query: this.$route.query }"
            v-if="!inModal && redirectRoute"
          >
            <el-button>{{ $t('cancel') }}</el-button>
          </router-link>
          <el-button
            v-if="!hideSubmit"
            @click="$emit('submit')"
            type="primary"
            :disabled="submitDisabled"
            :loading="loading"
          >
            {{ submitButtonLabel }}
          </el-button>
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageSwitcher from '@/components/LanguageSwitcher'

export default {
  props: [
    'redirectRoute',
    'modalLabel',
    'loading',
    'inModal',
    'submitLabel',
    'submitDisabled',
    'hideLanguageSwitcher',
    'subtitle',
    'titleAddition',
    'hideSubmit'
  ],
  components: { LanguageSwitcher },
  computed: {
    isRevision() {
      return false
    },
    submitButtonLabel() {
      return this.submitLabel || this.$t('submit')
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  position: sticky;
  top: 0;
  z-index: 3;
  box-shadow: 0px 4px 3px -2px rgba(0, 0, 0, 0.1);
}

.nav {
  padding: 20px;
  align-items: center;
  background: #ffffff;
  display: flex;
  justify-content: space-between;
  & .el-button,
  .el-dropdown {
    margin-left: 10px;
  }

  &--title {
    font-size: 24px;
    margin: 0;
    font-weight: 300;
  }
}
</style>
